import { JetView, plugins } from 'webix-jet';

/**
 * ConfigurationView class extends JetView to create a configuration interface.
 */
export default class configurationView extends JetView {
    /**
     * Defines the UI configuration for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Unique identifier for the layout
                    type: 'wide', // Layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Unique identifier for the tab bar
                            height: 43, // Height of the tab bar
                            options: [
                                {
                                    id: 'customers.configuration.changePassword', // Tab ID for changing password
                                    value: _('Cambiar Contraseña'), // Translated tab label
                                },
                                {
                                    id: 'customers.configuration.securityChanges', // Tab ID for security changes
                                    value: _('Seguridad Cambios'), // Translated tab label
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
